window.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".slideshow-container-novo");
  if (!containers.length) return;

  containers.forEach((container) => {
    const slider = container.querySelector(".slider-novo");
    if (!slider) return;

    const originalSlides = Array.from(
      container.querySelectorAll(".slider__slide-novo")
    );

    const totalSlides = originalSlides.length;
    if (!totalSlides) return;

    const autoplayEnabled = (container.dataset.autoplay || "false") === "true";
    const slideSpeed = Number(container.dataset.speed || 5000);

    let currentSlide = 0;
    let isTransitioning = false;
    let autoplayTimer = null;
    let isVisibleInViewport = false;

    if (totalSlides > 1) {
      const firstClone = originalSlides[0].cloneNode(true);
      firstClone.setAttribute("aria-hidden", "true");
      slider.appendChild(firstClone);
    }

    const dots = Array.from(
      container.querySelectorAll(".slider__dots-novo .dot")
    );

    function getVisualIndex(index) {
      if (totalSlides <= 0) return 0;
      if (index >= totalSlides) return 0;
      if (index < 0) return totalSlides - 1;
      return index;
    }

    function updateDots(index = currentSlide) {
      if (!dots.length) return;
      const visualIndex = getVisualIndex(index);

      dots.forEach((dot) => dot.classList.remove("active"));
      if (dots[visualIndex]) dots[visualIndex].classList.add("active");
    }

    function goToSlide(index, withTransition = true) {
      slider.style.transition = withTransition ? "transform 1s ease-in-out" : "none";
      slider.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      updateDots(index);
    }

    function nextSlide() {
      if (isTransitioning || totalSlides <= 1) return;
      isTransitioning = true;

      currentSlide += 1;
      goToSlide(currentSlide, true);

      window.setTimeout(() => {
        if (currentSlide >= totalSlides) {
          currentSlide = 0;
          goToSlide(currentSlide, false);
        }
        isTransitioning = false;
      }, 1000);
    }

    function prevSlide() {
      if (isTransitioning || totalSlides <= 1) return;
      isTransitioning = true;

      if (currentSlide === 0) {
        currentSlide = totalSlides;
        goToSlide(currentSlide, false);
      }

      window.setTimeout(() => {
        currentSlide -= 1;
        goToSlide(currentSlide, true);

        window.setTimeout(() => {
          isTransitioning = false;
        }, 1000);
      }, 20);
    }

    function startAutoplay() {
      if (!autoplayEnabled || totalSlides <= 1 || autoplayTimer || !isVisibleInViewport || document.hidden) {
        return;
      }

      autoplayTimer = window.setInterval(nextSlide, slideSpeed);
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function restartAutoplay() {
      if (!autoplayEnabled || totalSlides <= 1) return;
      stopAutoplay();
      startAutoplay();
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isVisibleInViewport = entry.isIntersecting;

          if (entry.isIntersecting && !document.hidden) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(container);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        if (isTransitioning) return;

        const idx = parseInt(dot.dataset.slide || "", 10);
        if (!Number.isFinite(idx)) return;

        currentSlide = idx;
        goToSlide(currentSlide, true);
        restartAutoplay();
      });
    });

    let startX = 0;
    let isDragging = false;

    function onMouseDown(e) {
      isDragging = true;
      startX = e.pageX;
    }

    function onTouchStart(e) {
      isDragging = true;
      startX = e.touches[0].pageX;
    }

    function onMouseUp(e) {
      if (!isDragging) return;
      handleSwipe(e.pageX);
    }

    function onTouchEnd(e) {
      if (!isDragging) return;
      handleSwipe(e.changedTouches[0].pageX);
    }

    function onMouseLeave() {
      isDragging = false;
    }

    function handleSwipe(endX) {
      const deltaX = endX - startX;

      if (deltaX > 50) {
        prevSlide();
        restartAutoplay();
      } else if (deltaX < -50) {
        nextSlide();
        restartAutoplay();
      }

      isDragging = false;
    }

    slider.addEventListener("mousedown", onMouseDown);
    slider.addEventListener("touchstart", onTouchStart, { passive: true });
    slider.addEventListener("mouseup", onMouseUp);
    slider.addEventListener("mouseleave", onMouseLeave);
    slider.addEventListener("touchend", onTouchEnd, { passive: true });

    goToSlide(0, false);
    updateDots(0);
  });
});